import { useEffect, useRef, useState } from 'react'

import { useConnect } from 'redux-bundler-hook'

import createLogger from '~/src/Lib/Logging'

const logger = createLogger('Harvest/useHarvestEntity')

const useHarvestEntity = id => {
  const {
    harvests,
    doHarvestFetch,
  } = useConnect(
    'selectHarvests',
    'doHarvestFetch',
  )

  const currentHarvestId = Number(id)

  const [harvest, setHarvest] = useState(null)

  const storeHarvest = harvests[currentHarvestId]

  const currentHarvestNotInStore = !storeHarvest
  const currentHarvestExistedLastRender = harvest && harvest.id === currentHarvestId

  // Update return value
  if (harvest && currentHarvestNotInStore) {
    setHarvest(null)
    logger.debug('harvest unset', { harvest })
  } else if (storeHarvest && harvest !== storeHarvest) {
    setHarvest(storeHarvest)
    logger.debug('harvest set', { storeHarvest })
  }

  // Prevent attempts at re-fetching a removed entity
  const removedSetRef = useRef(new Set())
  if (currentHarvestNotInStore && currentHarvestExistedLastRender) {
    logger.debug('harvest removed from store', { harvest })
    removedSetRef.current.add(currentHarvestId)
  }
  const currentHarvestWasRemoved = removedSetRef.current.has(currentHarvestId)

  const shouldFetchHarvest = currentHarvestId && (
    (currentHarvestNotInStore && !currentHarvestWasRemoved)
    || (storeHarvest && storeHarvest.payloadType !== 'entity')
  )
  useEffect(() => {
    if (shouldFetchHarvest) {
      logger.debug('fetching harvest...', currentHarvestId)
      doHarvestFetch(currentHarvestId)
    }
  }, [currentHarvestId, doHarvestFetch, shouldFetchHarvest])

  return harvest
}

export default useHarvestEntity
